import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fw-bold" }
const _hoisted_2 = { class: "fw-normal" }

import { computed } from 'vue'
import ExamRevision from '../../api/v2/models/exam_revision'
import { format } from 'date-fns'
import { qEditorState } from '../stores'


export default /*@__PURE__*/_defineComponent({
  __name: 'RevisionItemComponent',
  props: {
    examRevision: {}
  },
  setup(__props: any) {

const props = __props

const currentExamRevision = computed(() => qEditorState.currentExamRevision)

const isActive = computed(() => {
  return currentExamRevision.value && currentExamRevision.value.id === props.examRevision.id
})

const chooseExamRevision = () => {
  qEditorState.setCurrentExamRevision({ examRevision: props.examRevision })
}

const dateFormat = (date: string | Date) => {
  const dateObj = typeof date === 'string' ? new Date(date) : date
  return format(dateObj, 'MM/dd/yyyy HH:mm')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["list-group-item ms-3", { active: isActive.value }]),
    onClick: chooseExamRevision
  }, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(dateFormat(__props.examRevision.createdAt)), 1 /* TEXT */),
    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.examRevision.user.name), 1 /* TEXT */)
  ], 2 /* CLASS */))
}
}

})